// Hosts a recipient could never open: local dev servers and private networks.
const isPrivateHost = (hostname: string): boolean =>
  hostname === 'localhost' ||
  hostname.endsWith('.local') ||
  hostname.includes(':') || // IPv6 literal
  /^(127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|0\.0\.0\.0$)/.test(hostname);

/**
 * Where a lead's saved-build link (Save to WhatsApp / email) should point.
 *
 * The page the visitor is on: this app is deployed per environment at different
 * places (`autodome.metadome.ai/v2/<id>/<env>/` on dev and staging, its own domain
 * in production), so a fixed host + path can only be right for one of them. The
 * old hard-coded `autodome.metadome.ai/<id>/<env>/` is the Autodome 1.0 deployment.
 *
 * `fallback` (that fixed address) is kept where the page's own address is no use to
 * a recipient: local dev servers, private networks, non-web pages, and the in-showroom
 * kiosk build.
 */
export function resolveSaveLinkBase(
  fallback: string,
  location: Pick<Location, 'protocol' | 'hostname' | 'origin' | 'pathname'>,
  isShowroom: boolean,
): string {
  const publicWebPage = /^https?:$/.test(location.protocol) && !isPrivateHost(location.hostname);
  if (isShowroom || !publicWebPage) return fallback;
  return `${location.origin}${location.pathname}`;
}
